module.exports = "/lucky-balls/img/weager/balls/normal/LB_7.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/normal/LB_7.png
// module id = 1190
// module chunks = 0